import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { toast } from 'sonner';

const TwitchCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setAuthToken, setIsLoggedIn } = useContext(AuthContext);

  useEffect(() => {
    // Token is in the URL fragment (#token=...) to keep it out of server logs
    const hash   = window.location.hash.slice(1);
    const params = new URLSearchParams(hash);
    const token  = params.get('token');
    const error  = searchParams.get('error');

    if (error) {
      toast.error(`Authentication failed: ${error}`);
      navigate('/account');
      return;
    }

    if (token) {
      // Store token in localStorage and context
      localStorage.setItem('auth_token', token);
      setAuthToken(token);
      setIsLoggedIn(true);
      toast.success('Successfully logged in with Twitch!');

      const isNew = params.get('is_new') === '1';
      // Give a small delay to ensure state updates are processed
      setTimeout(() => {
        navigate(isNew ? '/follow-suggestions' : '/account');
      }, 100);
    } else {
      toast.error('No token received from Twitch');
      navigate('/account');
    }
  }, [searchParams, navigate, setAuthToken, setIsLoggedIn]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-white">Completing authentication...</p>
      </div>
    </div>
  );
};

export default TwitchCallback;
